import React from "react";
import { inp, lbl } from "../shared";

export function ContentTab({ ctx }) {
  const { content, setContent, saveContent } = ctx;
  return (
      <div className="max-w-2xl">
        <h1 className="serif text-3xl mb-8">Website Text & Translations</h1>
        <div className="space-y-5">
          {[
            ["hero_headline_en", "Hero Headline (EN)"], ["hero_headline_ar", "Hero Headline (AR)"],
            ["hero_sub_en", "Hero Subtext (EN)"], ["hero_sub_ar", "Hero Subtext (AR)"],
            ["hero_lines_en", "Hero Tagline Lines (EN) — one per line"], ["hero_lines_ar", "Hero Tagline Lines (AR) — one per line"],
            ["story_en", "Our Story (EN)"], ["story_ar", "Our Story (AR)"],
            ["perfumer_en", "The Perfumer — House Intro (EN)"], ["perfumer_ar", "The Perfumer — House Intro (AR)"],
            ["perfumer_name_en", "Perfumer Name (EN)"], ["perfumer_name_ar", "Perfumer Name (AR)"],
            ["perfumer_bio_en", "Perfumer Bio (EN)"], ["perfumer_bio_ar", "Perfumer Bio (AR)"],
          ].map(([k, l]) => (
            <div key={k}>
              <label className={lbl}>{l}</label>
              <textarea dir={k.endsWith("_ar") ? "rtl" : "ltr"} rows={(k.includes("story") || k.includes("bio") || k === "perfumer_en" || k === "perfumer_ar") ? 5 : 2} value={content[k] || ""} onChange={(e) => setContent({ ...content, [k]: e.target.value })} data-testid={`content-${k}`} className={inp} />
            </div>
          ))}
        </div>
        <button onClick={saveContent} data-testid="save-content" className="mt-6 bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.2em] px-8 py-3 hover:bg-[#E7CBA9]">Save</button>
      </div>
  );
}
